import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { RR_MODAL_BUTTON_TYPE } from '../../models/modal-button-type.enum';
import { RRModalButtonsModel } from '../../models/modal-buttons.model';
import { RR_MODAL_CONTENT_TYPE } from '../../models/modal-content-type.enum';
import { RRModalModel } from '../../models/modal.model';

@Component({
  selector: 'rr-confirm-delete-modal',
  templateUrl: './confirm-delete-modal.component.html',
  styleUrls: ['./confirm-delete-modal.component.scss'],
})
export class ConfirmDeleteModalComponent implements AfterViewInit, OnChanges {
  public deleteModalSettings: RRModalModel;
  public deleteModalButtons: RRModalButtonsModel[];
  public readonly MODAL_CONTENT_TYPE = RR_MODAL_CONTENT_TYPE;

  @Input() show: boolean;
  @Input() modalTitle: string;
  @Input() contentType: RR_MODAL_CONTENT_TYPE;
  @Input() modalContentString: string;
  @Input() modalContentTemplate: TemplateRef<any>;
  @Output()
  modalClosed: EventEmitter<RR_MODAL_BUTTON_TYPE> = new EventEmitter();

  constructor() {
    this.deleteModalButtons = [
      {
        label: 'Yes',
        return: 'yes',
        class: 'btn btn-outline-danger',
        closeModal: true,
      },
      {
        label: 'No',
        return: 'no',
        class: 'btn btn-outline-secondary',
        closeModal: true,
      },
    ];

    this.deleteModalSettings = {
      title: 'Are you sure?',
      text: '',
      class: 'modal-body text-center',
      buttons: this.deleteModalButtons,
    };
  }

  ngAfterViewInit() {
    if (this.modalTitle) {
      this.deleteModalSettings.title = this.modalTitle;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['modalTitle'] &&
      changes['modalTitle'].previousValue !== changes['modalTitle'].currentValue
    ) {
      this.deleteModalSettings.title = this.modalTitle;
    }
  }

  public onDeleteModalButtonClicked(event: RRModalButtonsModel) {
    if (event.return === 'yes') {
      this.modalClosed.emit(RR_MODAL_BUTTON_TYPE.CONFIRM);
    } else {
      this.modalClosed.emit(RR_MODAL_BUTTON_TYPE.CANCEL);
    }
  }

  public onShowModalChange(event: boolean): void {
    this.show = event;
    this.modalClosed.emit(RR_MODAL_BUTTON_TYPE.CANCEL);
  }
}
